<template>
  <div class="col-lg-2">
    <router-link :to="{ name: forwardPath }">
      <div class="tile home_item">
        <img class="home_img" :src="fullImagePath" />
        <p class="home_title">{{ title }}</p>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    imagePath: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    forwardPath: {
      type: String,
      default: '',
    },
  },
  computed: {
    fullImagePath() {
      return require('@/assets/images/' + this.imagePath);
    },
  },
};
</script>

<style scoped>
.home_item {
  width: 175px;
  height: 175px;
  background-color: white;
}
.home_img {
  object-fit: contain;
  padding-top: 48px;
  width: 50px;
  height: 106px;
}
.home_title {
  position: relative;
  left: 0%;
  top: 0%;
  transform: none;
  width: 175px;
  margin-top: 15px;
}
</style>
